import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'

Vue.use(Router)

//解决vue中的NavigationDuplicated 点击本页面会报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  // mode:'history',
  // base: '/smiswebsitesaas/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '云处方科技',   // 标题设置
        hasFooter:true,
        hasHeader:true
      }
    },
    {
      path: '/DownLoad',
      name: 'DownLoad',
      component: () => import('../pages/DownLoad'),
      meta: {
        title: '下载',
        hasHeader:true,
        hasFooter:true,
      }
    },
    {
      path: '/About',
      name: 'About',
      component: () => import('../pages/About'),
      meta: {
        title: '关于我们',
        hasFooter:false,
        hasHeader:true
      }
    },
    {
      path: '/Case',
      name: 'Case',
      component: () => import('../pages/Case'),
      meta: {
        title: '案例展示',
        hasHeader:true,
        hasFooter:true,
      }
    },
    {
      path: '/News/detail',
      name: 'newsDetail',
      component: () => import('../pages/News/detail'),
      meta: {
        title: '新闻详情',
        hasHeader:true,
        hasFooter:true,
      }
    },
    {
      path: '/News',
      name: 'News',
      component: () => import('../pages/News'),
      meta: {
        title: '新闻资讯',
        hasHeader:true,
        hasFooter:true,
      }
    },
    {
      path: '/Pros',
      name: 'Pros',
      component: () => import('../pages/Pros'),
      meta: {
        title: '推荐产品',
        hasHeader:true,
        hasFooter:true,
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('../pages/Login'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/Rigster',
      name: 'Rigster',
      component: () => import('../pages/Rigster'),
      meta: {
        title: '注册'
      }
    },
    {
      path: '/Findpass',
      name: 'Findpass',
      component: () => import('../pages/Findpass'),
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/User',
      name: 'User',
      component: () => import('../pages/User'),
      meta: {
        title: '个人中心',
        hasHeader:true,
        hasFooter:false,
      },
      redirect:'/User/userinfo',
      children:[
        {
          path:"/User/userinfo",
          name:"userinfo",
          component: () => import('../pages/User/userinfo'),
          meta: {
            title: '个人资料',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/password",
          name:"password",
          component: () => import('../pages/User/password'),
          meta: {
            title: '修改密码',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/institution",
          name:"institution",
          component: () => import('../pages/User/institution'),
          meta: {
            title: '我的机构',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/community",
          name:"community",
          component: () => import('../pages/Community/community'),
          meta: {
            title: '我的机构',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/basic",
          name:"basic",
          component: () => import('../pages/Ins/basic'),
          meta: {
            title: '基本信息',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/busyness",
          name:"busyness",
          component: () => import('../pages/Ins/busyness'),
          meta: {
            title: '业务展示',
            hasHeader:true,
            hasFooter:false,
          }
        },
        {
          path:"/User/inews",
          name:"inews",
          component: () => import('../pages/Ins/inews'),
          meta: {
            title: '资讯公告',
            hasHeader:true,
            hasFooter:false,
          }
        }
      ]
    }
  ]
})




export default router;



// WEBPACK FOOTER //
// ./src/router/index.js